import Head from "next/head";
import {
  ROBOTS_INDEX,
  SITE_NAME,
  buildCanonicalUrl,
  getSiteUrl,
} from "@/lib/siteSeo";
import { AGENDA_LANDING_PATH } from "./agendaLandingContent";
import {
  AGENDA_SEO_DESCRIPTION,
  AGENDA_SEO_TITLE,
  buildAgendaLandingJsonLd,
} from "./agendaLandingSeo";

export function AgendaLandingSeoHead() {
  const siteUrl = getSiteUrl();
  const canonical = buildCanonicalUrl(AGENDA_LANDING_PATH);
  const ogImage = `${siteUrl}/images/agendamento-online.jpeg`;
  const jsonLd = buildAgendaLandingJsonLd(siteUrl);

  return (
    <>
      <Head>
        <title>{AGENDA_SEO_TITLE}</title>
        <meta name="description" content={AGENDA_SEO_DESCRIPTION} />
        <link rel="canonical" href={canonical} />
        <meta name="robots" content={ROBOTS_INDEX} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:title" content={AGENDA_SEO_TITLE} />
        <meta property="og:description" content={AGENDA_SEO_DESCRIPTION} />
        <meta property="og:url" content={canonical} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:locale" content="pt_BR" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={AGENDA_SEO_TITLE} />
        <meta name="twitter:description" content={AGENDA_SEO_DESCRIPTION} />
        <meta name="twitter:image" content={ogImage} />
      </Head>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
}
